import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

//source:
//https://github.com/christianliebel/angular2-click-outside/blob/master/clickOutside.directive.ts
@Directive({
  selector: '[popClickOutside]'
})
export class ClickOutsideElementDirective {
  public constructor(private elementRef: ElementRef<HTMLElement>) {}

  @Output()
  public popClickOutside = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement?: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.popClickOutside.emit(event);
    }
  }
}
